<template>
  <div class="wrapper">
    <div class="page-wrapper">
      <div class="container-xl">
        <!-- Page title -->
        <div class="page-header d-print-none">
          <div class="row align-items-center">
            <div class="col">
              <!-- Page pre-title -->
              <h2 class="page-title">
                Dashboard
              </h2>
            </div>
            <!-- Page title actions -->
          </div>
        </div>
      </div>
      <div class="page-body">
        <div class="container-xl">
          <div class="alert alert-danger mb-3" role="alert">
            本服務因應 VASP 條款，已停止服務
          </div>
          <div class="row row-deck row-cards">
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="subheader">總額</div>
                    <div class="ms-auto lh-1">
                      <div class="dropdown">
                        <a class="dropdown-toggle text-muted" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">過去 7 天</a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a 
                            class="dropdown-item getRevenue" 
                            href="javascript:void(0);" 
                            @click.prevent="getRevenue(7)">過去 7 天
                          </a>
                          <a 
                            class="dropdown-item getRevenue" 
                            href="javascript:void(0);" 
                            @click.prevent="getRevenue(30)">過去 30 天
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-baseline">
                    <div class="h1 mb-0 me-2">$ {{ revenueTotal }}</div>
                  </div>
                </div>
                <apexchart
                  height="200"
                  ref="revenueChart"
                  type="line"
                  :options="options"
                  :series="series"
                ></apexchart>
              <div class="resize-triggers"><div class="expand-trigger"><div style="width: 305px; height: 140px;"></div></div><div class="contract-trigger"></div></div></div>
            </div>
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="subheader">顧客數</div>
                    <div class="ms-auto lh-1">
                      <div class="dropdown">
                        <a class="dropdown-toggle text-muted" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">過去 7 天</a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a 
                            class="dropdown-item getCustomers" 
                            href="javascript:void(0);" 
                            @click.prevent="getCustomersTotal(7)">過去 7 天
                          </a>
                          <a 
                            class="dropdown-item getCustomers" 
                            href="javascript:void(0);" 
                            @click.prevent="getCustomersTotal(30)">過去 30 天
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-baseline">
                    <div class="h1 mb-0 me-2">{{ customersTotal }}</div>
                  </div>
                </div>
                <apexchart
                  height="200"
                  ref="customersChart"
                  type="line"
                  :options="options"
                  :series="series"
                ></apexchart>
              <div class="resize-triggers"><div class="expand-trigger"><div style="width: 305px; height: 140px;"></div></div><div class="contract-trigger"></div></div></div>
            </div>
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="subheader">已付款訂單</div>
                    <div class="ms-auto lh-1">
                      <div class="dropdown">
                        <a class="dropdown-toggle text-muted" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">過去 7 天</a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a 
                            class="dropdown-item getSuccessOrder" 
                            href="javascript:void(0);" 
                            @click.prevent="getSuccessOrder(7)">過去 7 天
                          </a>
                          <a 
                            class="dropdown-item getSuccessOrder" 
                            href="javascript:void(0);" 
                            @click.prevent="getSuccessOrder(30)">過去 30 天
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-baseline">
                    <div class="h1 mb-0 me-2">{{ successOrder }}</div>
                  </div>
                </div>
                <apexchart
                  height="200"
                  ref="successOrderChart"
                  type="bar"
                  :options="options"
                  :series="series"
                ></apexchart>
              <div class="resize-triggers"><div class="expand-trigger"><div style="width: 305px; height: 140px;"></div></div><div class="contract-trigger"></div></div></div>
            </div>
            <div class="col-lg-12 overflow-auto">
              <div class="row row-cards">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body border-bottom py-3">
                      <div class="d-flex">
                        <div class="text-muted">
                          每頁
                          <div class="mx-2 d-inline-block">
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model.number="size"
                              size="3"
                              v-on:change="changeSize()"
                            />
                          </div>
                          筆
                        </div>
                        <!--<div class="ml-auto text-muted">
                          搜尋:
                          <div class="ml-2 d-inline-block">
                            <input type="text" class="form-control form-control-sm" />
                          </div>
                        </div>-->
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table card-table table-vcenter text-nowrap datatable">
                        <thead>
                          <tr>
                            <th class="w-1">
                              交易序號
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-sm text-dark icon-thick"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <polyline points="6 15 12 9 18 15"></polyline>
                              </svg>
                            </th>
                            <th>商店提供編號</th>
                            <th>幣種</th>
                            <th>金額</th>
                            <th>狀態</th>
                            <th>最後更新時間</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in transactions" :key="item.id">
                            <td>
                              <span class="text-muted">{{ item.id }}</span>
                            </td>
                            <td>
                              <span class="text-muted">{{
                                item.merchantCompareOrderId
                              }}</span>
                            </td>
                            <td>
                              {{ item.currency }}
                            </td>
                            <td>
                              <span class="flag flag-country-us"></span>
                              {{ item.amount }}
                            </td>
                            <td>
                              <span
                                :class="
                                  item.paymentStatus
                                    ? 'badge bg-success mr-1'
                                    : 'badge bg-danger mr-1'
                                "
                              ></span>
                              {{ item.paymentStatus ? "已付款" : "未付款" }}
                            </td>
                            <td>{{ item.createdAt }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="card-footer">
                      <div class="row">
                        <div class="col-2">
                          <label class="form-check form-switch m-0">
                            測試模式
                            <input
                              class="form-check-input position-static"
                              type="checkbox"
                              :checked="testMode"
                              v-model="testMode"
                              @change="
                                getTransactionList(
                                  currency,
                                  order,
                                  sort,
                                  pagination.currentPage,
                                  size,
                                  startDate,
                                  endDate,
                                  testMode
                                )
                              "
                            />
                          </label>
                        </div>
                        <!--<div class="col-6">
                          <p class="m-0 text-muted">
                            Showing
                            <span>{{
                              size <= pagination.total ? size : pagination.total
                            }}</span>
                            of <span>{{ pagination.total }}</span> entries
                          </p>
                        </div>-->
                        <div class="col-10">
                          <ul class="pagination m-0 ms-auto float-right">
                            <li
                              class="page-item"
                              :class="{ disabled: pagination.currentPage === 1 }"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click.prevent="
                                  getTransactionList(
                                    currency,
                                    order,
                                    sort,
                                    pagination.currentPage - 1,
                                    size,
                                    startDate,
                                    endDate,
                                    testMode
                                  )
                                "
                              >
                                &laquo; Prev
                              </a>
                            </li>
                            <li
                              class="page-item"
                              v-for="page in pagination.totalPageCount"
                              :key="page"
                              :class="{ active: pagination.currentPage === page }"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click.prevent="
                                  getTransactionList(
                                    currency,
                                    order,
                                    sort,
                                    page,
                                    size,
                                    startDate,
                                    endDate,
                                    testMode
                                  )
                                "
                                >{{ page }}</a
                              >
                            </li>
                            <li
                              class="page-item"
                              :class="{
                                disabled:
                                  pagination.currentPage === pagination.totalPageCount,
                              }"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click.prevent="
                                  getTransactionList(
                                    currency,
                                    order,
                                    sort,
                                    pagination.currentPage + 1,
                                    size,
                                    startDate,
                                    endDate,
                                    testMode
                                  )
                                "
                              >
                                Next &raquo;
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      token: "",
      revenueTotal: 0,
      customersTotal: 0,
      successOrder: 0,
      // apexchart: { options: {}, series: {} },
      options: {
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "",
          data: [],
        },
      ],
      transactions: [],
      currency: "",
      startDate: "",
      endDate: "",
      order: "",
      sort: "",
      page: 1,
      size: 10,
      testMode: false,
      pagination: {
        totalPageCount: 0,
        currentPage: 0,
        total: 0,
      },
    };
  },
  methods: {
    async getSuccessOrder(days = 7) {
      const API = `${process.env.VUE_APP_API_URL}/admin_api/${process.env.VUE_APP_API_VERSION}/analysis/me/order/revenue/${days}`;
      try {
        const res = await this.$http.get(API, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (res.data.status === "success") {
          let successOrder = 0;
          const successOrderData = res.data.data.map((e) => {
            successOrder += e.count;
            return e.count
          });
          this.successOrder = successOrder;

          this.$refs.successOrderChart.updateOptions({
              chart: {
              type: "bar",
              fontFamily: 'inherit',
              height: 40.0,
              sparkline: {
                enabled: true
              },
              animations: {
                enabled: false
              },
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                columnWidth: '50%',
              }
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              opacity: 1,
            },
            series: [{
              name: "Profits",
              data: successOrderData
            }],
            grid: {
              strokeDashArray: 4,
            },
            xaxis: {
              labels: {
                padding: 0,
              },
              tooltip: {
                enabled: false
              },
              axisBorder: {
                show: false,
              },
              type: 'datetime',
            },
            yaxis: {
              labels: {
                padding: 4
              },
            },
            labels: res.data.data.map((e) => e.createdAt),
            colors: ["#206bc4"],
            legend: {
              show: false,
            },
          });
        }
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
        console.log(err)
      }
    },
    async getRevenue(days = 7) {
      const API = `${process.env.VUE_APP_API_URL}/admin_api/${process.env.VUE_APP_API_VERSION}/analysis/me/order/revenue/${days}`;
      try {
        const res = await this.$http.get(API, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (res.data.status === "success") {
          let revenueTotal = 0;
          const revenueData = res.data.data.map((e) => {
            revenueTotal += e.amount;
            return e.amount
          });
          this.revenueTotal = revenueTotal
          this.$refs.revenueChart.updateOptions({
            chart: {
              type: "area",
              fontFamily: 'inherit',
              height: 40.0,
              sparkline: {
                enabled: true
              },
              animations: {
                enabled: false
              },
              toolbar: {
                show: false
              }
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              opacity: .16,
              type: 'solid'
            },
            stroke: {
              width: 2,
              lineCap: "round",
              curve: "smooth",
            },
            series: [{
              name: "Revenue",
              data: revenueData
            }],
            grid: {
              strokeDashArray: 4,
            },
            xaxis: {
              labels: {
                padding: 0,
              },
              tooltip: {
                enabled: false
              },
              axisBorder: {
                show: false,
              },
              type: 'datetime',
            },
            yaxis: {
              labels: {
                padding: 4
              },
            },
            labels: res.data.data.map((e) => e.createdAt),
            colors: ["#206bc4"],
            legend: {
              show: false,
            },
          });
        }
      } catch(err) {
        console.log(err)
      }
    },
    async getCustomersTotal(days = 7) {
      const API = `${process.env.VUE_APP_API_URL}/admin_api/${process.env.VUE_APP_API_VERSION}/analysis/me/order/customers/${days}`;
      try {
        const res = await this.$http.get(API, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (res.data.status === "success") {
          let customersTotal = 0;
          const data = res.data.data.map((e) => {
            customersTotal += e.count;
            return e.count
          });
          this.customersTotal = customersTotal
          this.$refs.customersChart.updateOptions({
              chart: {
              type: "line",
              fontFamily: 'inherit',
              height: 40.0,
              sparkline: {
                enabled: true
              },
              animations: {
                enabled: false
              },
              toolbar: {
                show: false
              }
            },
            fill: {
              opacity: 1,
            },
            stroke: {
              width: [2, 1],
              dashArray: [0, 3],
              lineCap: "round",
              curve: "smooth",
            },
            series: [{
              name: "Customers",
              data: data
            }],
            grid: {
              strokeDashArray: 4,
            },
            xaxis: {
              labels: {
                padding: 0,
              },
              tooltip: {
                enabled: false
              },
              type: 'datetime',
            },
            yaxis: {
              labels: {
                padding: 4
              },
            },
           labels: res.data.data.map((e) => e.createdAt),
            colors: ["#206bc4"],
            legend: {
              show: false,
            },
          });
        }
      } catch(err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
        console.log(err)
      }
    },
    getTransactionList(
      currency = "USDT",
      order = "amount",
      sort = "desc",
      page = 1,
      size = 10,
      startDate = "",
      endDate = "",
      testMode
    ) {
      testMode = testMode ? 1 : 0;
      let api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/order/list?currency=${currency}&order=${order}&sort=${sort}&size=${size}&page=${page}&testMode=${testMode}`;
      this.currency = currency;
      this.order = order;
      this.sort = sort;
      this.size = size;
      this.page = page;
      const vm = this;

      if (startDate !== "") {
        api += `&startDate=${startDate}`;
        this.startDate = startDate;
      }
      if (endDate !== "") {
        api += `&endDate=${endDate}`;
        this.endDate = endDate;
      }

      this.$http
        .get(api, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(function(res) {
          if (res.data.status === "success") {
            vm.transactions = res.data.data;
            vm.pagination.currentPage = res.data.page;
            vm.pagination.total = res.data.total;
            vm.pagination.totalPageCount = Math.ceil(res.data.total / vm.size);
          }
        });
    },
    changeSize() {
      this.getTransactionList(
        this.currency,
        this.order,
        this.sort,
        this.page,
        this.size,
        this.startDate,
        this.endDate
      );
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getRevenue();
    this.getCustomersTotal()
    this.getSuccessOrder()
    this.getTransactionList();
  },
};
</script>
